import { FormikHelpers } from "formik";

export type Flow = "dummy-account" | "full-account";
export type FormAction = "createAccount" | "createDummyAccount" | "login";
export type FormActionDummyAccount = "createDummyAccount" | "login";
export type FormActionFullAccount = "createAccount" | "login";

export enum AuthKey {
  KIND = "kind",
  EMAIL = "email",
  LOGIN = "login",
  MAILING_LIST = "mailingList",
  PASSWORD = "password",
  TERMS = "termsPolicy",
}

export type AuthKeyEnumValue = `${AuthKey}`;
export type AuthValues = {
  [AuthKey.KIND]: "auth";
  [AuthKey.EMAIL]: string;
  [AuthKey.LOGIN]: string;
  [AuthKey.MAILING_LIST]: boolean;
  [AuthKey.PASSWORD]: string;
  [AuthKey.TERMS]: boolean;
};
export type AuthValuesOptionals = {
  [P in keyof AuthValues]?: AuthValues[P];
};
export type AuthSubmit = (
  values: AuthValues,
  formikHelpers: FormikHelpers<AuthValues>
) => void;

export type SocialLoginSuccess = () => void;
